<div class="ziti-page-container ziti-cert-authorities-container">
  <lib-list-page-header [title]="title"
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
  (actionClicked)="headerActionClicked($event)"></lib-list-page-header>

  <lib-data-table [tableId]="'certificate-authorities'"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columnDefinitions]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [emptyMsg]="'No Certificate Authorities defined, Click the plus to add a Configuration.'"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    (gridReady)="gridReady($event)"
    >
  </lib-data-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
